import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function TavoliniPauseCard() {
    const [state, setState] = useState(null);
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState("");

    useEffect(() => {
        api.get("/admin/db/tavolini-pause").then((r) => setState(r.data))
            .catch(() => { setState({ paused: false }); setErr("Stato pausa non disponibile, riprova."); });
    }, []);

    const toggle = async () => {
        setBusy(true);
        try {
            const r = await api.put("/admin/db/tavolini-pause", { paused: !state?.paused });
            setState((s) => ({ ...s, paused: r.data.paused }));
            setErr("");
        } catch (e) {
            setErr(e.response?.data?.detail || "Errore: pausa non aggiornata");
        } finally {
            setBusy(false);
        }
    };

    if (!state) return null;
    const paused = state.paused;
    return (
        <div className="op-card p-4 mb-4 flex flex-wrap items-center justify-between gap-3" data-testid="tavolini-pause-card"
            style={{ borderLeft: `3px solid ${paused ? "rgb(var(--tc-ff3b30))" : "rgb(var(--tc-7ce38b))"}` }}>
            <div>
                <div className="op-label text-[10px] text-tff7a1a">// TAVOLINI AUTOMATICI</div>
                <div className="text-sm text-tffffff mt-1" data-testid="tavolini-pause-status">
                    {paused ? "IN PAUSA: nessun risultato d'ufficio viene assegnato" : "Attivi: le partite scadute ricevono il tavolino"}
                </div>
                <div className="op-mono text-[10px] text-t8f95a3 mt-1">La pausa non viene toccata dai ripristini degli snapshot.</div>
                {err && <div className="op-mono text-[11px] text-tff3b30 mt-1" data-testid="tavolini-pause-error">{err}</div>}
            </div>
            <button type="button" onClick={toggle} disabled={busy} data-testid="tavolini-pause-toggle"
                className="op-btn px-4 py-2 border disabled:opacity-50"
                style={{ color: paused ? "rgb(var(--tc-7ce38b))" : "rgb(var(--tc-ff3b30))", borderColor: "currentColor" }}>
                {busy ? "…" : paused ? "Riattiva tavolini" : "Metti in pausa"}
            </button>
        </div>
    );
}
